export default function SectionTitle({ children }: { children: React.ReactNode }) {
    return (
        <div className="homepage-section-title">
            <div className="homepage-section-title__container h-full">
                <span className={'font-bold text-haug-ivory-100 uppercase'}>{children}</span>
            </div>
        </div>
    );
}
